<template>
	<div>
		<base-header class="pb-6 bg-light">
			<!-- Page header -->
			<b-row aling-v="center" class="py-4">
				<b-col cols="12" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">Cancel Location</h6>
				</b-col>
				<b-col cols="12" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>
		</base-header>
		<b-container class="pt-5 w-50" style="min-width: max-content; max-width: 600px;">
			<b-card>
				<b-form>
					<b-row>
						<b-col xl="4" lg="4" sm="6">
							<p class="mt-3">
								<span class="h3">IMSI</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="6">
							<b-form-group label-for="input-1">
								<b-form-input
									type="text"
									:state="!submitDisabled"
									v-model="cancelLocationForm.imsiInfo"
								></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col xl="4" lg="4" sm="6">
							<p class="mt-3">
								<span class="h3">Destination Address</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="6">
							<b-form-group label-for="input-1">
								<b-form-input
									id="input-1"
									:state="true"
									v-model="cancelLocationForm.addressInfo"
								></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col xl="4" lg="4" sm="6">
							<p class="mt-3">
								<span class="h3">Action</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="6">
							<b-form-group label="" v-slot="{ariaDescribedby}">
								<b-form-radio-group
									v-model="cancelLocationForm.actionInfo"
									:options="actionOptions"
									:state="true"
									value-field="key"
									text-field="text"
									plain
									stacked
								>
								</b-form-radio-group>
							</b-form-group>
						</b-col>
					</b-row>
					<hr />
					<div class="mt-3 d-flex justify-content-between">
						<base-button type="danger" title="Close" v-on:click="reset()"> Clear </base-button>
						<base-button
							type="primary"
							title="Search"
							v-on:click="cancelLocationSubmit"
							:loading="submitLoading"
							:disabled="submitDisabled"
						>
							Submit
						</base-button>
					</div>
				</b-form>
			</b-card>
		</b-container>
	</div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import handleResponse from "../../../common/directive/handlResponse";
import searchDetailService from "../../../common/api-services/search-details-service";
import initService from "../../../common/api-services/init-service";
export default {
	name: "discrepancy-check",
	components: {
		RouteBreadCrumb,
	},
	mounted() {
		document.title = "Troubleshooting - Cancel Location";

		this.noAccess =
			!initService.getUserRoles().includes("Administrator") &&
			!initService.getUserRoles().includes("CARRIER_ADMIN") &&
			!initService.getUserRoles().includes("PORTAL_ADMIN ");

		//don't do anything unless the user has access
		if (this.noAccess) {
			this.$router.push("/home");
		}
	},
	data() {
		return {
			actionOptions: [
				{text: "Cancel Voice", key: "Voice"},
				{text: "Cancel Data", key: "Data"},
				{text: "Cancel Voice and Data", key: "All"},
			],
			cancelLocationForm: {
				imsiInfo: "",
				addressInfo: "",
				actionInfo: "",
			},
			submitLoading: false,
		};
	},
	computed: {
		submitDisabled() {
			return this.cancelLocationForm.imsiInfo.length !== 15;
		},
	},
	methods: {
		cancelLocationSubmit(event) {
			event.preventDefault();
			this.submitLoading = true;
			let {imsiInfo, addressInfo, actionInfo} = this.cancelLocationForm;
			searchDetailService
				.cancelLocation(imsiInfo, addressInfo, actionInfo)
				.then(res => {
					let {type, msg} = handleResponse.apiResponse(res);
					this.$toast(msg, {type: type});
					this.cancelLocationForm = {
						imsiInfo: "",
						addressInfo: "",
						actionInfo: "",
					};
					this.submitLoading = false;
				})
				.catch(err => {
					this.submitLoading = false;
					let {type, msg} = handleResponse.apiResponse(err);
					this.$toast(msg, {type: type});
				});
		},
		reset() {
			this.cancelLocationForm = {
				imsiInfo: "",
				addressInfo: "",
				actionInfo: "",
			};
		},
	},
};
</script>
